<template>
  <div class="wrapper">
    <DocumentsFilters :default="filters" @applyFilters="applyFilters" />

    <div class="card">
      <div class="card-block">
        <CoachsDocumentsToValidatedList :coachs="coachs" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DocumentsFilters from "@/components/coach/DocumentsFilters.vue";
import CoachsDocumentsToValidatedList from "@/components/coach/CoachsDocumentsToValidatedList.vue";

export default {
  components: {
    DocumentsFilters,
    CoachsDocumentsToValidatedList,
  },
  data() {
    return {
      filters: {
        commercials: [],
        coachManagers: [],
      },
      coachs: [],
      shared: [],
      priv: [],
    };
  },
  computed: {
    coachsHeader() {
      return "Coachs &mdash; documents à valider (" + this.coachs.length + ")";
    },
    sharedHeader() {
      return "Partagés (" + this.shared.length + ")";
    },
    privateHeader() {
      return "Privés (" + this.priv.length + ")";
    },
  },

  async created() {
    await this.loadDocuments();

    this.$api.get("/users/documents").then((res) => {
      this.priv = res.data.filter((d) => !d.shared);
      this.shared = res.data.filter((d) => !!d.shared);

      /* load shared documents !user.id */
    });
  },
  methods: {
    apiUploads() {
      return axios.defaults.baseURL + "uploads";
    },
    apiAuthorization() {
      return {
        Authorization: localStorage.getItem("token"),
      };
    },

    async loadDocuments() {
      const { data } = await this.$api.get("/users/coachs/documents", {
        params: {
          commercials: this.filters.commercials.map((c) => c.value),
          coachManagers: this.filters.coachManagers.map((c) => c.value),
        },
      });

      this.coachs = [];
      data.forEach((user) => {
        if (user.documents) {
          user.documents.forEach((doc) => {
            if (!doc.validatedAt) {
              this.coachs.push({
                document: doc,
                coachId: user.id,
                coachEmail: user.email,
                coachName: user.coach.name,
                coachManagerEmail: user.refCoachManagerEmail,
                coachManager: user.refCoachManager,
              });
            }
          });
        }
      });
    },

    async applyFilters(form) {
      this.filters = {
        ...this.filters,
        ...form,
      };

      await this.loadDocuments();
    },

    privateUploaded(file, response) {
      this.$api.put("/users/document/" + response.id).then((res) => {
        this.priv = res.data.filter((d) => !d.shared);
      });
    },
    sharedUploaded(file, response) {
      this.$api
        .put("/users/document/" + response.id, {
          shared: true,
        })
        .then((res) => {
          this.shared = res.data.filter((d) => !!d.shared);
        });
    },

    addParamsToDropzoneRequest(file, xhr, formData) {
      formData.append("folder", "users");
    },
  },
};
</script>
